import React from "react";
import SectionHeadline from "./SectionHeadline";
import slider1 from "../assets/hol5.jpg";
import { FaFacebook, FaInstagram } from "react-icons/fa";

export default function Contact() {
  return (
    <div className="md:px-0 px-4 flex justify-center items-center">
      <main className="flex flex-col gap-10 md:w-10/12 w-full">
        <div className="flex flex-col justify-center">
          <SectionHeadline
            title="Contact us (HVTC)"
            backgroundImage={slider1}
          />

          <div className="mx-auto">
            <ul className="md:mt-12  mt-10 flex flex-wrap md:gap-16  gap-10 items-center">
              {contactMethods.map((item, idx) => (
                <li key={idx}>
                  <h4 className=" text-[19px] text-gray-700 font-medium hover:text-gray-500 duration-500 cursor-pointer">
                    {item.title}
                  </h4>
                  <div className="mt-3 flex items-center gap-x-3">
                    <div className="flex-none text-primary-400 font-semibold animate-bounce duration-700">
                      {item.icon}
                    </div>
              
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="md:text-[18px] text-[17px] text-gray-600 cursor-pointer hover:text-gray-500 duration-200"
                    >
                      {item.contact}
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="md:mt-10  mt-6 flex justify-center items-center">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5941.529608702524!2d85.33189957282295!3d27.69088715198103!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19957c935b35%3A0x75b06ec216c597d5!2sHoly%20Vision%20Technical%20Campus!5e0!3m2!1sen!2snp!4v1720629912169!5m2!1sen!2snp"
            title="map"
            referrerPolicy="no-referrer-when-downgrade"
            className="md:w-[1500px] md:h-[500px] h-96 w-full"
          ></iframe>
        </div>
      </main>
    </div>
  );
}

const contactMethods = [
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
        />
      </svg>
    ),
    contact: "Thapagaun, New Baneshwor  Kathmandu ",
    title: "Our Location",
  },
  {
    icon: <FaFacebook className="w-6 h-6" />,
    contact: "https://www.facebook.com/hvtcampus",
    title: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61561311225933&mibextid=ZbWKwL",
  },
  {
    icon: <FaInstagram className="w-6 h-6" />,
    contact: "https://www.instagram.com/hvtcampus",
    title: "Instagram",
    url: "https://www.instagram.com/hvtcampus",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
        />
      </svg>
    ),
    contact: "01-5244745 , 9846904128 , 9841329360",
    title: "Phone",
    url: "#",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
        />
      </svg>
    ),
    contact: "hvtcampus@gmail.com",
    title: "Email",
    url: "mailto:hvtcampus@gmail.com",
  },
];
